export const comingSoonPages = ['notifications'];
